module.exports = require("ink-text-input");